import React, {Component} from 'react';
import {Button, Col} from "react-bootstrap";
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    prepareSelectOptionsList,
    actionsFormatter,
    historyDataFormatter,
    dateFormatter,linkFormatter,
    customFormatter,
    getFieldByPathFormatter
} from 'util/Utils';

  import config from  '../../../config';
import {Link} from "react-router";


class InventoryProjectsListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            currentRecord: {},
            adminFulfillments: []

        };
    }

    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = []

     //   menuItemsMap.push({onClick: 'editRecord', label: 'Edit'})
  //      if (!row.Deleted) {
            menuItemsMap.push({onClick:(row)=>{
                this.props.showRemoveDialog(row);
            }, label: 'Delete'})
      //  }


        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }



    editRecord(row) {
        this.props.editRecord(row);
    }



    render() {
        // console.log('props', this.props  );
        return (
            <div className="  list-group">
                <BootstrapTable data={this.props.tableData} ref='table'
                                remote={true}
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } } >

                    <TableHeaderColumn width="40px" dataField="StartDate" dataAlign="center"
                                       dataFormat={ dateFormatter }
                                       editable={ false }
                                       formatExtraData={ {'path': 'StartDate', 'format': 'MM/DD'} }
                                       dataSort={true}>Start Date</TableHeaderColumn>

                    {this.props.currentTab !== 'MonthlyReports' &&
                    <TableHeaderColumn width="40px" dataField="EndDate" dataAlign="center"
                                       dataFormat={ dateFormatter }
                                       editable={ false }
                                       formatExtraData={ {'path': 'EndDate', 'format': 'MM/DD'} }
                                       dataSort={true}>End Date</TableHeaderColumn>
                    }
                    <TableHeaderColumn  width="100px" dataField="id" isKey={true}  hidden={true} autoValue={ true } hiddenOnInsert>Id</TableHeaderColumn>
                    <TableHeaderColumn width="40px"  dataAlign="center" dataField='MarketName'
                                       dataSort={true}>Location</TableHeaderColumn>
                    {this.props.currentTab !== 'MonthlyReports' &&
                    <TableHeaderColumn width="100px" dataField='Status' dataAlign="center"
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['Status'], format: (value, arg2) => {
                            return _.startCase(value)
                        }
                    }} dataSort={true}>Status</TableHeaderColumn>
                    }
                    <TableHeaderColumn width="35px" dataAlign="center"
                                       dataFormat={(cell, row, extra)=>{
                                           if (_.get(row, extra.labelPath, 0) >0) {
                                               return linkFormatter(cell, row, extra)
                                           } else {
                                               return <div>{_.get(row, extra.labelPath, extra.label ? extra.label : 'Link')} </div>
                                           }

                                       } }
                                       formatExtraData={ {
                                           labelPath: ['InventoryCount'],
                                           path: ['_id'],
                                           formatPathValue:(value)=>{
                                               return   encodeURIComponent(value)
                                           },
                                           placeholder: '[inventory_project_id]',
                                           template: config.getEnvironment().serverBaseURL +'/admin/products?InventoryProjectID=[inventory_project_id]',
                                       }  }
                                       dataField='InventoryCount'
                                       editable={ false } dataSort={true}>Inventory Count</TableHeaderColumn>




                    <TableHeaderColumn width="80px" dataAlign="center" columnClassName={'actions-column'}
                                       editable={ false }
                                       dataFormat={ this.customActionsFormatter.bind(this) }>Actions</TableHeaderColumn>
                </BootstrapTable>

            </div>
        );
    }
}


export default InventoryProjectsListTable;
